import { render, staticRenderFns } from "./KonvaAutomationInlineAddMenu.vue?vue&type=template&id=420604f3&scoped=true"
import script from "./KonvaAutomationInlineAddMenu.vue?vue&type=script&lang=js"
export * from "./KonvaAutomationInlineAddMenu.vue?vue&type=script&lang=js"
import style0 from "./KonvaAutomationInlineAddMenu.vue?vue&type=style&index=0&id=420604f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420604f3",
  null
  
)

export default component.exports